// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        inlineEditor: {
            enabled: true,
            autoSave: true,
            emptyRow: true
        },
        actions: {
            listAction: "/api/WorkFlowStep/GetWorkFlowStepDetail/",
            deleteAction: "/api/WorkFlowStep/",
            updateAction: "/api/WorkFlowStep",
            createAction: "/api/WorkFlowStep",
            //searchAction: "/api/Client/GetClientDetail/"
        },

        fields: {
            StepNo: {
                required: true,
                tooltip: "Enter Step Number",
                weightage: 1,
                sortable: true,
                type: "Number",
                title: "Number"
            },
            StepCode: {
                required: true,
                sortable: true,
                type: "TextInput",
                title: "Code",
                redirect: {
                    menuId: 80,
                    action: '/Admin/System/WorkFlowDefinition/WorkFlowDefinitionForm'
                }
            },
            StepName: {
                required: true,
                tooltip: "Enter Step Name",
                weightage: 2,
                sortable: true,
                type: "TextInput",
                title: "Name"
            },
            SortOrder: {
                required: true,
                tooltip: "Enter Step Sort Order",
                type: "Number",
                weightage: 2,
                sortable: true,
                title: "Sort Order"
            },
            LockStatus: {
                required: true,
                autocomplete: true,
                type: "ComboBox",
                title: "Lock Status",
                weightage: 2
            },
            TriggerService: {
                required: true,
                tooltip: "Trigger Service",
                weightage: 1,
                sortable: true,
                type: "Number",
                title: "Trigger Service"
            },
            WorkFlowService: {
                type: "Hidden"
            },
            WorkFlowServiceId: {
                required: true,
                autocomplete: true,
                type: "ComboBox",
                weightage: 2,
                sortable: true,
                title: "Service Name"
            },
            Published: {
                type: "Hidden"
            },
            DueDate: {
                type: "Hidden"
            },
            CreatedById: {
                type: "Hidden"
            },
            CreatedDate: {
                type: "Hidden"
            },
            UpdatedById: {
                type: "Hidden"
            },
            UpdatedDate: {
                type: "Hidden"
            },
            SysSchemaId: {
                type: "Hidden"
            },
            SysJSON: {
                type: "Hidden"
            },
            CusSchemaId: {
                type: "Hidden"
            },
            CusJSON: {
                type: "Hidden"
            },
            OriginBusinessUnitId: {
                type: "Hidden"
            },
            WorkFlowStepId: {
                primaryKey: true
            },
            WorkFlowDefinitionId: {
                parent: true
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
            
        },
        formUpdated(state, payload) { },
        
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },
        //#. fn_selectionChanged function
        selectionChanged(state, context) {
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },
        formUpdated: ({ commit, rootState }, payload) => {
            commit('formUpdated', { rootState, payload });
        },
        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        }
    }
}